import React, { useEffect, useState, useRef } from 'react';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDienstenOpen, setIsDienstenOpen] = useState(false);
  const [isMobileDienstenOpen, setIsMobileDienstenOpen] = useState(false);
  const dienstenRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dienstenRef.current && !dienstenRef.current.contains(event.target as Node)) {
        setIsDienstenOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };
  const handleNavigation = (path: string, sectionId?: string) => {
    setIsMobileMenuOpen(false);
    setIsDienstenOpen(false);
    setIsMobileDienstenOpen(false);
    if (location.pathname === '/' && sectionId) {
      scrollToSection(sectionId);
    } else if (path === '/' && sectionId) {
      navigate('/');
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      navigate(path);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  const dienstenItems = [{
    label: 'Webdesign Alkmaar',
    action: () => window.open('https://webdesignalkmaar.nl/', '_blank')
  }, {
    label: 'SEO',
    action: () => handleNavigation('/seo')
  }, {
    label: 'WordPress',
    action: () => window.open('https://webdesignalkmaar.nl/', '_blank')
  }, {
    label: 'Hosting',
    action: () => handleNavigation('/hosting')
  }, {
    label: 'E-mail',
    action: () => handleNavigation('/email')
  }];
  const navItems = [{
    label: 'CorePrint',
    action: () => window.open('https://coreprint.nl/', '_blank'),
    highlight: true
  }, {
    label: 'Diensten',
    isDropdown: true
  }, {
    label: 'Cases',
    action: () => handleNavigation('/', 'client-cases')
  }, {
    label: 'Over ons',
    action: () => handleNavigation('/over-ons')
  }, {
    label: 'Bibliotheek',
    action: () => handleNavigation('/bibliotheek')
  }, {
    label: 'Vacatures',
    action: () => handleNavigation('/sollicitatie')
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-md' : ''}`} style={{
      height: isScrolled ? '64px' : '80px'
    }} data-id="element-376">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full" data-id="element-377">
          <div className="flex items-center justify-between h-full" data-id="element-378">
            {/* Logo */}
            <button onClick={() => handleNavigation('/')} className="flex-shrink-0 hover:opacity-80 transition-opacity" data-id="element-379">
              <img src="https://cdn.magicpatterns.com/uploads/9aWYg1KoQ1vAxmEDFRCMUb/Logo_Noord.png" alt="Noord Digital" className={`w-auto transition-all duration-300 ${isScrolled ? 'h-8' : 'h-10'}`} data-id="element-380" />
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-1" data-id="element-381">
              {navItems.map((item, index) => {
              if (item.isDropdown) {
                return <div key={index} ref={dienstenRef} className="relative" data-id="element-382">
                      <button onClick={() => setIsDienstenOpen(!isDienstenOpen)} className="flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 text-[#111827] hover:bg-[#F7F8FA]" data-id="element-383">
                        {item.label}
                        <ChevronDownIcon className={`h-4 w-4 ml-1 transition-transform duration-200 ${isDienstenOpen ? 'rotate-180' : ''}`} data-id="element-384" />
                      </button>

                      {isDienstenOpen && <div className="absolute top-full left-0 mt-1 w-52 bg-white rounded-xl shadow-lg border border-gray-100 py-2 z-50" data-id="element-385">
                          {dienstenItems.map((subItem, subIndex) => <button key={subIndex} onClick={subItem.action} className="w-full text-left px-4 py-2.5 text-sm text-[#111827] hover:bg-[#F7F8FA] hover:text-[#004AC7] transition-colors" data-id="element-386">
                              {subItem.label}
                            </button>)}
                        </div>}
                    </div>;
              }
              return <button key={index} onClick={item.action} className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${item.highlight ? 'text-[#004AC7] font-bold hover:bg-[#E6F0FF]' : 'text-[#111827] hover:bg-[#F7F8FA]'}`} data-id="element-387">
                    {item.label}
                  </button>;
            })}
            </nav>

            {/* Desktop CTA + Mobile CTA & Hamburger */}
            <div className="flex items-center gap-3" data-id="element-388">
              {/* CTA Button - visible on all screens */}
              <button onClick={() => handleNavigation('/', 'contact')} className="px-5 py-2.5 text-white font-semibold text-sm hover:opacity-90 transition-all duration-200 shadow-sm" style={{
              backgroundColor: '#004AC7',
              borderRadius: '6px'
            }} data-id="element-389">
                Kennismaking
              </button>

              {/* Mobile Menu Button */}
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 rounded-lg hover:bg-[#F7F8FA] transition-colors" aria-label="Toggle menu" data-id="element-390">
                {isMobileMenuOpen ? <XIcon className="h-6 w-6 text-[#111827]" data-id="element-391" /> : <MenuIcon className="h-6 w-6 text-[#111827]" data-id="element-392" />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <>
          <div className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-393" />

          <div className="fixed left-0 right-0 z-40 bg-white shadow-2xl lg:hidden rounded-b-2xl" style={{
        top: isScrolled ? '64px' : '80px'
      }} data-id="element-394">
            <nav className="px-4 py-6 space-y-1" data-id="element-395">
              {navItems.map((item, index) => {
            if (item.isDropdown) {
              return <div key={index} data-id="element-396">
                      <button onClick={() => setIsMobileDienstenOpen(!isMobileDienstenOpen)} className="w-full flex items-center justify-between px-4 py-3 text-base font-medium rounded-lg text-[#111827] hover:bg-[#F7F8FA] transition-all duration-200" data-id="element-397">
                        {item.label}
                        <ChevronDownIcon className={`h-5 w-5 transition-transform duration-200 ${isMobileDienstenOpen ? 'rotate-180' : ''}`} data-id="element-398" />
                      </button>
                      {isMobileDienstenOpen && <div className="ml-4 mt-1 space-y-1 border-l-2 border-[#E6F0FF] pl-3" data-id="element-399">
                          {dienstenItems.map((subItem, subIndex) => <button key={subIndex} onClick={subItem.action} className="w-full text-left px-4 py-2.5 text-sm text-[#6B7280] hover:text-[#004AC7] hover:bg-[#F7F8FA] rounded-lg transition-colors" data-id="element-400">
                              {subItem.label}
                            </button>)}
                        </div>}
                    </div>;
            }
            return <button key={index} onClick={item.action} className={`w-full text-left px-4 py-3 text-base font-medium rounded-lg transition-all duration-200 ${item.highlight ? 'text-[#004AC7] font-bold bg-[#E6F0FF]' : 'text-[#111827] hover:bg-[#F7F8FA]'}`} data-id="element-401">
                    {item.label}
                  </button>;
          })}
            </nav>
          </div>
        </>}

      {/* Spacer to prevent content jump */}
      <div className={`transition-all duration-300 ${isScrolled ? 'h-16' : 'h-20'}`} data-id="element-402" />
    </>;
};